import GatewayTimeout from './504';
import Maintenance from './maintenance';
import PageNotFound from './404';
import InternalServerError from './500';
import BadGateway from './502';
const ErrorScreen = {
  GatewayTimeout,
  Maintenance,
  PageNotFound,
  InternalServerError,
  BadGateway
};
export default ErrorScreen;
//# sourceMappingURL=index.js.map